import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como terapeuta natural?',
    a: 'Especialmente si recién empezás. El sistema te da la estructura clínica desde el primer paciente. No tenés que improvisar ni esperar años de experiencia para trabajar con protocolos respaldados por ciencia. El Tomo I es tu base, el Tomo II tu laboratorio, el Tomo III tu criterio clínico y el Tomo IV te abre un mundo de preparaciones avanzadas cuando estés listo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga de todos los archivos PDF. El acceso es inmediato, en cualquier dispositivo y de por vida.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'No es necesario. Podés usarlo digitalmente desde tablet, celular o computadora. Si preferís imprimirlo, todos los archivos están diseñados para impresión en A4.'
  }, {
    q: '¿Qué diferencia a este kit de información que puedo buscar gratis en internet?',
    a: 'La información gratuita en internet sobre plantas medicinales argentinas es fragmentada, contradictoria, sin base científica y sin criterio clínico. Este kit integra 385 páginas de contenido validado por CONICET, ANMAT, INTA y Farmacopea Argentina, estructurado específicamente para el terapeuta argentino en ejercicio. Incluye desde la ficha técnica hasta la preparación avanzada. No existe en ningún otro lado.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días sin preguntas con devolución del 100%. Si en una semana no lo encontrás útil para tu práctica, te devolvemos todo. Sin formularios ni drama.'
  }, {
    q: '¿Puedo compartirlo con otros terapeutas?',
    a: 'El kit es de uso personal y profesional exclusivo. Está protegido por derechos de autor. Si querés que un colega lo tenga, podés recomendarle la compra directa. Cada terapeuta merece tener su propio sistema.'
  }, {
    q: '¿Las plantas del kit se consiguen en Argentina?',
    a: 'Sí. Toda la enciclopedia está basada en flora nativa argentina y plantas disponibles en el mercado herbolario nacional. El Bonus 3 incluye además la guía para conseguirlas y evaluarlas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-73" data-mp="33meoodxru6m2">
      <div className="text-center mb-12" data-id="element-74" data-mp="33m4u0d1s7ba1">
        <h2 className="md:text-4xl font-display font-bold mb-4 flex items-center justify-center text-[22px] text-brand-purpleDark" data-id="element-75" data-mp="33kbnqyv2yt2k">
          <span className="mr-3" data-id="element-76" data-mp="2ulzz32dry5cr">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>

      <div className="space-y-4" data-id="element-77" data-mp="1n86e7hq9znqs">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-purple/25 bg-white/80" data-id="element-78" data-mp="1n9hidinmuxif" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-79" data-mp="3uug7dvpncvnl">
              <span className="font-medium pr-8 text-brand-purpleDark text-[14px] md:text-base lg:text-lg" data-id="element-80" data-mp="7n44907yare7">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-81" data-mp="hdyqi4l75qzn" />
            </button>
            <AnimatePresence data-id="element-82" data-mp="qgrkwgpoeitp">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-83" data-mp="vej8iyjafis3">
                  <div className="px-6 pb-5 text-brand-text border-t border-brand-purple/20 pt-4 bg-white/60 text-[13px] md:text-base leading-relaxed" data-id="element-84" data-mp="1wz942fh1j04f">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};